import { render, staticRenderFns } from "./Turismo.vue?vue&type=template&id=84a0c9da&"
import script from "./Turismo.vue?vue&type=script&lang=js&"
export * from "./Turismo.vue?vue&type=script&lang=js&"
import style0 from "./Turismo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports